var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
export var DetailsBlock = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 2.5rem;\n"], ["\n  display: flex;\n  margin-bottom: 2.5rem;\n"])));
export var DetailsColumn = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 50%;\n\n  span {\n    font-size: 1.75rem;\n    color: ", ";\n    font-weight: 700;\n    display: inline-block;\n    width: 100%;\n    text-align: ", ";\n  }\n"], ["\n  width: 50%;\n\n  span {\n    font-size: 1.75rem;\n    color: ", ";\n    font-weight: 700;\n    display: inline-block;\n    width: 100%;\n    text-align: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var alignRight = _a.alignRight;
    return (alignRight ? 'right' : 'left');
});
export var DetailsLink = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n"], ["\n  text-decoration: none;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary;
});
var templateObject_1, templateObject_2, templateObject_3;
